import SubdomainBoundary from './SubdomainBoundary'

export default SubdomainBoundary